/*
 * Logic here: Take the consent settings from the local Storage
 * Nothing in Local Storage -> Take settings from dataLayer (!)
 */

const permissionMapping = [
    { 'gtm' : 'analytics_storage', 'dom' : 'consent-analytics_storage' },
    { 'gtm' : 'ad_storage', 'dom' : 'consent-ad_storage' },
    { 'gtm' : 'personalization_storage', 'dom' : 'consent-personalization_storage' },
    { 'gtm' : 'ad_user_data', 'dom' : 'consent-ad_user_data' },
    { 'gtm' : 'ad_personalization', 'dom' : 'consent-ad_personalization' },
    { 'gtm' : 'ad_security_storage', 'dom' : 'consent-security_storage' },
    { 'gtm' : 'ad_personalization_storage', 'dom' : 'consent-ad_personalization' },
];

const consentMode = localStorage.getItem("consentMode");

const checkConsentOptions = (selections) => {
    permissionMapping
        .forEach(({gtm, dom}) => {
            const checkbox = document.getElementById(dom)

            if (selections.hasOwnProperty(gtm) && checkbox) {
                checkbox.checked = (selections[gtm] === 'granted')
            }
        })
}

if (consentMode !== null) {
    checkConsentOptions(JSON.parse(consentMode));
}else{
    if(window.dataLayer && window.dataLayer[0] && window.dataLayer[0][2]) {
        checkConsentOptions(window.dataLayer[0][2]);
    }
}


const consentSaveButton = document.getElementById('consent_save');

function setConsent(consent) {
    const consentMode = {
        analytics_storage: consent.analytics_storage ? 'granted' : 'denied',
        ad_storage: consent.ad_storage ? 'granted' : 'denied',
        personalization_storage: consent.personalization_storage ? 'granted' : 'denied',
        ad_user_data: consent.ad_user_data ? 'granted' : 'denied',
        ad_personalization: consent.ad_personalization ? 'granted' : 'denied',
        security_storage: consent.necessary ? 'granted' : 'denied',
        functionality_storage: consent.necessary ? 'granted' : 'denied',
    };

    if (typeof gtag === 'function') {
        gtag('consent', 'update', consentMode);
    }

    localStorage.setItem('consentMode', JSON.stringify(consentMode));
}

if (consentSaveButton) {
    consentSaveButton.addEventListener("click", (evt) => {

        consentSaveButton.classList.toggle('disabled')

        evt.preventDefault()
        evt.stopImmediatePropagation()

        const parent = consentSaveButton.parentNode
        const successText = consentSaveButton.dataset.success

        setConsent({
            necessary: true,
            analytics_storage: document.getElementById("consent-analytics_storage")?.checked ?? false,
            ad_storage: document.getElementById("consent-ad_storage")?.checked ?? false,
            personalization_storage: document.getElementById("consent-personalization_storage")?.checked ?? false,
            ad_user_data: document.getElementById("consent-ad_user_data")?.checked ?? false,
            ad_personalization: document.getElementById("consent-ad_personalization")?.checked ?? false,
            security_storage: document.getElementById("consent-security_storage")?.checked ?? false,
            functionality_storage: document.getElementById("consent-functionality_storage")?.checked ?? false,
        });

        parent.insertAdjacentHTML(
            'beforeend',
            `<p class="cookie-save-success">
                    <i class="cookie-save-success__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 31" enable-background="new 0 0 40 31" xml:space="preserve">
                            <path fill="currentColor" d="M39.5,0.5c-0.6-0.6-1.6-0.7-2.3,0c0,0,0,0,0,0l-26,26l-8.5-8.5c-0.6-0.6-1.6-0.6-2.3,0c-0.6,0.6-0.6,1.6,0,2.2l9.6,9.6c0.6,0.6,1.6,0.6,2.3,0L39.5,2.8C40.1,2.1,40.1,1.1,39.5,0.5z"/>
                        </svg>
                    </i>
                    ${successText}
                </p>`
        )

        setTimeout(function() {
            const cookieSuccess = document.querySelector(".cookie-save-success")
            if (cookieSuccess) {
                cookieSuccess.remove()
                consentSaveButton.classList.toggle('disabled')
            }
        }, 3000)

    });
}